import { api } from 'repositories/api';
import { BasketErrorModel, BasketPaymentErrorModel, BasketApiErrorModel, BasketHybrisFormErrorModel } from 'models/Errors';
import { ErrorEndpoint, ApiErrorResponseCodes, ErrorResponseCodes, WarningResponseCodes } from 'store/middleware';
import { BasketActionTypes } from 'store/basket/basket.types';
import { CheckoutActionTypes } from 'store/checkout/checkout.types';
import { PaymentActionTypes } from 'store/payment/payment.types';

export class LogsHelper {
    public async error(error: BasketErrorModel | BasketPaymentErrorModel | BasketApiErrorModel | BasketHybrisFormErrorModel | Error): Promise<void> {
        await api.logs.sendErrorMessage(error);
    }

    public getLogEndpoint(errorObject: any): string {
        const responseCode = errorObject.error.responseStatus;

        if (responseCode) {
            return this.errorUrlByResponseCode(responseCode);
        }

        const additionalErrorData = errorObject.error.innerError?.data;
        const additionalDataFoundEndpoint = additionalErrorData ? this.errorUrlByAdditionalData(additionalErrorData) : undefined;

        if (additionalErrorData && additionalDataFoundEndpoint) {
            return additionalDataFoundEndpoint;
        }

        const errorSourceFoundEndpoint = this.errorUrlByErrorSource(errorObject.error.source);

        if (errorObject.error.source && errorSourceFoundEndpoint) {
            return errorSourceFoundEndpoint;
        }

        return ErrorEndpoint.ErrorUrl;
    }

    private errorUrlByResponseCode(responseCode: any): string {
        if (responseCode in ApiErrorResponseCodes) {
            return ErrorEndpoint.ApiErrorUrl;
        }

        if (responseCode in ErrorResponseCodes) {
            return ErrorEndpoint.ErrorUrl;
        }

        if (responseCode in WarningResponseCodes) {
            return ErrorEndpoint.WarningUrl;
        }

        return ErrorEndpoint.InformationUrl;
    }

    private errorUrlByAdditionalData(additionalErrorData: any): string | undefined {
        for (const dataObject of additionalErrorData) {
            if (dataObject.key === 'responseStatus' && dataObject.value in ApiErrorResponseCodes) {
                return ErrorEndpoint.ApiErrorUrl;
            }

            if (dataObject.key === 'responseStatus' && dataObject.value in ErrorResponseCodes) {
                return ErrorEndpoint.ErrorUrl;
            }

            if (dataObject.key === 'responseStatus' && dataObject.value in WarningResponseCodes) {
                return ErrorEndpoint.WarningUrl;
            }

            if (dataObject.key === 'formName') {
                return ErrorEndpoint.WarningUrl;
            }

            if (dataObject.key === 'code') {
                return ErrorEndpoint.ErrorUrl;
            }
        }

        return undefined;
    }

    private errorUrlByErrorSource(source: string): string | undefined {
        switch (source) {
            case BasketActionTypes.CALCULATE_DELIVERY_COST_ERROR:
            case CheckoutActionTypes.LOAD_DELIVERY_DETAILS_ERROR:
            case CheckoutActionTypes.LOGIN_PROCESS_ERROR:
            case CheckoutActionTypes.CHECK_EMAIL_ERROR:
            case CheckoutActionTypes.FINANCE_APPLICATION_TIMEOUT_ERROR:
                return ErrorEndpoint.InformationUrl;

            case BasketActionTypes.LOAD_BASKET_ERROR:
            case BasketActionTypes.UPDATE_BASKET_ITEM_QUANTITY_ERROR:
            case BasketActionTypes.REMOVE_BASKET_ITEM_ERROR:
            case BasketActionTypes.REMOVE_SOFAGLIDE_ERROR:
            case BasketActionTypes.CHECK_SOFAGLIDE_FOR_UPDATE_ERROR:
            case BasketActionTypes.UPDATE_SOFAGLIDE_ERROR:
            case BasketActionTypes.REMOVE_SOFASHIELD_ERROR:
            case BasketActionTypes.UPDATE_SOFASHIELD_ERROR:
            case BasketActionTypes.REFRESH_AVAILABLE_UPSELLS_ERROR:
            case BasketActionTypes.REMOVE_BASKET_ERROR:
            case BasketActionTypes.REMOVE_USER_INFO_ERROR:
            case BasketActionTypes.SAVE_CURRENT_PAGE_ERROR:
            case CheckoutActionTypes.INIT_CHECKOUT_PAGE_ERROR:
            case CheckoutActionTypes.INIT_ORDER_SUMMARY_PAGE_ERROR:
            case CheckoutActionTypes.INIT_PAYMENT_PAGE_ERROR:
            case CheckoutActionTypes.SET_DELIVER_NOT_BEFORE_ERROR:
            case CheckoutActionTypes.FIND_LAST_ORDER_ERROR:
            case CheckoutActionTypes.FIND_ADDRESS_ERROR:
            case CheckoutActionTypes.INIT_FIRST_FINANCE_APPLICATION_PAGE_ERROR:
            case CheckoutActionTypes.PREPROCESS_REDIRECT_TO_NEXT_STEP_ERROR:
            case CheckoutActionTypes.TRANSFER_BASKET_ERROR:
            case CheckoutActionTypes.INIT_COMPLETE_RESET_PASSWORD_PAGE_ERROR:
            case PaymentActionTypes.CHANGE_PAYMENT_TYPE_ERROR:
            case PaymentActionTypes.UPDATE_CARD_PAYMENT_ERROR:
            case PaymentActionTypes.UPDATE_IFC_PAYMENT_ERROR:
                return ErrorEndpoint.WarningUrl;
        }

        return undefined;
    }
}

export const logsHelper = new LogsHelper();